<template>
  <NavigationLayout
    :navigationTitle="$t('paymentRegistration')"
    :navigationBarStyle="{
      'top': 'var(--safe-area-inset-top, 0px)',
    }"
    :navigationContentStyle="{
      'padding-top': 'calc(44px + var(--safe-area-inset-top, 0px))',
    }"
  >
    <div id="mypage__wrapper" slot="contents">
      <div id="mypage__container">
        <section>
          <ListSubheader :title="$t('loggedInAccount')" />
          <ListItem :title="$t('nickname')" :actionText="user.nickname" />
          <ListItem
            title="ID"
            :actionText="user.vlive_id"
            :style="
              userInJapanRegion || ipInWiseServiceRegion
                ? null
                : ListItemStyleSectionLast
            "
          />
          <template v-if="userInJapanRegion">
            <router-link
              tag="div"
              to="/mypage/payment_registration/bank"
              class="mypage__navigation"
            >
              <ListItem
                :title="$t('bankAccountInformation')"
                v-bind:hasDisclosure="true"
              />
            </router-link>
            <router-link
              tag="div"
              to="/mypage/payment_registration/personal"
              class="mypage__navigation"
            >
              <ListItem
                :title="$t('personalInfo2')"
                :hasDisclosure="true"
                :style="ipInWiseServiceRegion ? null : ListItemStyleSectionLast"
              />
            </router-link>
          </template>

          <!-- Wise用本人情報 -->
          <template v-if="ipInWiseServiceRegion">
            <router-link
              tag="div"
              to="/mypage/payment_registration/wise"
              class="mypage__navigation"
            >
              <ListItem
                :title="$t('personalInfo2')"
                :hasDisclosure="true"
                :style="ipInWiseServiceRegion ? ListItemStyleSectionLast : null"
              />
            </router-link>
          </template>
        </section>
        <section v-if="ipInWiseServiceRegion || userCanUseGiftCardExchange">
          <ListSubheader :title="$t('cashTransferPointExchange')" />
          <template v-if="ipInWiseServiceRegion">
            <router-link
              tag="div"
              to="/mypage/payment_registration/wise/payout"
              class="mypage__navigation"
            >
              <ListItem
                :title="$t('transferRequest')"
                :hasDisclosure="true"
                :style="
                  userCanUseGiftCardExchange ? null : ListItemStyleSectionLast
                "
              />
            </router-link>
          </template>
          <template v-if="userCanUseGiftCardExchange">
            <router-link
              tag="div"
              to="/mypage/payment_registration/gift"
              class="mypage__navigation"
            >
              <ListItem
                :title="$t('giftCodeExchange')"
                :hasDisclosure="true"
                :style="ListItemStyleSectionLast"
              />
            </router-link>
          </template>
        </section>
        <section>
          <ListSubheader :title="$t('history')" />
          <template v-if="userInJapanRegion">
            <router-link
              tag="div"
              to="/mypage/payment_histories"
              class="mypage__navigation"
            >
              <ListItem
                :title="$t('bankTransferHistory')"
                :hasDisclosure="true"
                :style="user.official === 0 ? null : ListItemStyleSectionLast"
              />
            </router-link>
            <router-link
              tag="div"
              to="/mypage/payment_histories/gift"
              class="mypage__navigation"
              v-if="user.official === 0"
            >
              <ListItem
                :title="$t('giftCodeExchangeHistory')"
                :hasDisclosure="true"
              />
            </router-link>
            <router-link
              tag="div"
              to="/mypage/payment_histories/total_transfer"
              class="mypage__navigation"
              v-if="user.official === 0"
            >
              <ListItem
                :title="$t('yearlyRewardAmount')"
                :hasDisclosure="true"
                :style="ipInWiseServiceRegion ? null : ListItemStyleSectionLast"
              />
            </router-link>
          </template>
          <!-- Wise送金申請履歴 -->
          <router-link
            tag="div"
            to="/mypage/payment_registration/wise/history"
            class="mypage__navigation"
            v-if="ipInWiseServiceRegion"
          >
            <ListItem
              :title="$t('wiseTransferHistory')"
              :hasDisclosure="true"
              :style="ListItemStyleSectionLast"
            />
          </router-link>
        </section>
        <div v-if="userInJapanRegion">
          <div :style="CautionsStyle">
            <p>
              {{ $t('livePointExchangeMessage1') }}
            </p>
            <p>{{ $t('livePointExchangeMessage2') }}</p>
            <p>
              {{ $t('livePointExchangeMessage3') }}
            </p>
            <p>
              {{ $t('livePointExchangeMessage4') }}
            </p>
            <p>{{ $t('livePointExchangeMessage5') }}</p>
            <p>{{ $t('livePointExchangeMessage6') }}</p>
            <p>{{ $t('livePointExchangeMessage7') }}</p>
          </div>
        </div>
      </div>
    </div>
  </NavigationLayout>
</template>

<script>
import API from '@/utils/API'
import NavigationLayout from '@/components/NavigationLayout.vue'
import ListItem from '@/components/ListItem.vue'
import ListSubheader from '@/components/ListSubheader.vue'
import MypageStyle from '@/styles/mypage'
import { apiV2 } from '@/api/appGatewayServerV2Api'
import { REGION_JP } from '@/i18n'

export default {
  components: {
    NavigationLayout,
    ListItem,
    ListSubheader,
  },
  computed: {
    userInJapanRegion: function () {
      // 日本以外の制限地域はすでに他ページに飛ばされているので、IP!=WIse利用地域 => IPは日本
      return !this.ipInWiseServiceRegion
    },
    userCanUseGiftCardExchange: function () {
      return this.userInJapanRegion && this.user?.official === 0
    },
  },
  data: function () {
    return {
      user: {},
      CautionsStyle: MypageStyle.Cautions,
      ipInWiseServiceRegion: false,
      ListItemStyleSectionLast: MypageStyle.ListItemSectionLast,
    }
  },
  methods: {
    fetchStreamerUser: async function () {
      try {
        const request = API.Request.streamerUserOwnerGet()
        const response = await API.load(request)
        return response.StreamerUser
      } catch (error) {
        return {}
      }
    },
    askInWiseServiceRegion: async function () {
      try {
        const response = await apiV2().wise.inServiceRegion()
        return {
          inWiseServiceRegion: response.inServiceRegion,
          wiseRegion: response.GeoIPRegion,
        }
      } catch (error) {
        return false
      }
    },
  },
  async created() {
    const [user, { inWiseServiceRegion, wiseRegion }] = await Promise.all([
      this.fetchStreamerUser(),
      this.askInWiseServiceRegion(),
    ])

    // [Wise用]アクセス元IPが制限対象地域だったら抜ける
    if (!inWiseServiceRegion && wiseRegion !== REGION_JP) {
      this.$router.push('/mypage').catch(() => {})
      return
    }

    this.user = user
    this.ipInWiseServiceRegion = inWiseServiceRegion
  },
}
</script>

<style scoped>
#mypage__wrapper {
  position: relative;
  height: auto;
  min-height: 100%;
  background-color: #fafafa;
}

#mypage__container {
  font-family: sans-serif;
  font-size: 14px;
  line-height: 1.43;
  color: #262626;
  padding-bottom: 80px;
}

#mypage__header {
  padding: 20px 14px;
  margin-top: 0;
  text-align: left;
  background-color: #ffffff;
  line-height: 1.5;
  color: #383838;
}

section {
  margin-top: 20px;
}

.mypage__navigation {
  cursor: pointer;
  pointer-events: auto;
}
</style>
